import type { SettlementLineRow, SettlementPayoutApiStatus } from "@/services/adminSettlementService";

export type Submitting =
  | "invoice"
  | "pay"
  | "revolut"
  | "summary"
  | "collect"
  | "supplier"
  | "replaceSupplier"
  | null;

/** Keep the operator's selection across data reloads when those lines still exist. */
export function selectionAfterReload(previous: Set<string>, lines: SettlementLineRow[]): Set<string> {
  const lineIds = new Set(lines.map((line) => line.id));
  return new Set([...previous].filter((id) => lineIds.has(id)));
}

export function buildDefaultRevolutReference(): string {
  const iso = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  const rand = crypto.randomUUID().slice(0, 8).toUpperCase();
  return `FLITRIP-${iso}-${rand}`;
}

export function isTerminalRevolutStatus(status: SettlementPayoutApiStatus): boolean {
  return status === "COMPLETED" || status === "FAILED" || status === "REVERTED";
}
